/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TableBody,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import { Check, Clear, ExpandMore } from '@material-ui/icons';
import userServices from '../../../../redux/services/userServices';
import StudentNeedsDialog from './StudentNeedsDialog';

const NeedsDialog = ({ open, setOpen, group }) => {
  const [studentsList, setStudentsList] = useState([]);
  const [globalNeeds, setGlobalNeeds] = useState({
    logistics: 0,
    sales: 0,
    marketing: 0,
    hr: 0,
    finance: 0,
    legal: 0,
    engineering: 0,
    production: 0,
    quality: 0,
    it: 0,
    otherPro: 0,
    news: 0,
    environment: 0,
    economy: 0,
    politics: 0,
    art: 0,
    sport: 0,
    travelling: 0,
    leisure: 0,
    education: 0,
    otherVoc: 0,
    meetings: 0,
    presentations: 0,
    negotiations: 0,
    emails: 0,
    telephoning: 0,
    otherWorksRelated: 0,
  });

  useEffect(async () => {
    if (group && group._id) {
      const res = await userServices.getStudentByGroup(group._id);
      if (res !== undefined && res !== null && res.length > 0) {
        setStudentsList(res);
        let globalNeedsObj = { ...globalNeeds };
        res.forEach((student) => {
          if (student.needs) {
            for (const need in student.needs) {
              for (const item in globalNeedsObj) {
                if (item === need && student.needs[need]) {
                  globalNeedsObj = { ...globalNeedsObj, [item]: globalNeedsObj[item] += 1 };
                }
              }
            }
          }
        });
        setGlobalNeeds(globalNeedsObj);
      }
    }
  }, [group]);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullScreen
    >
      <DialogContent>
        <Typography
          variant="h6"
          style={{
            marginBottom: '20px',
          }}
        >
          Needs by students
        </Typography>
        {studentsList.map((student) => (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMore style={{ color: '#FFF' }} />}
              style={{
                backgroundColor: '#152980',
                color: '#FFF',
                fontWeight: 'bold',
              }}
            >
              {student.name}
              {' '}
              {student.firstname}
            </AccordionSummary>
            <AccordionDetails style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <StudentNeedsDialog student={student} />
            </AccordionDetails>
          </Accordion>
        ))}
        <Typography
          variant="h6"
          style={{
            marginBottom: '20px',
            marginTop: '50px',
          }}
        >
          Global needs
        </Typography>
        <TableContainer style={{ marginTop: '20px', marginBottom: '10px' }}>
          <Table>
            <TableHead style={{ backgroundColor: '#DADFEA' }}>
              <TableRow>
                <TableCell colSpan={10} align="center">Professional/technical vocabulary</TableCell>
              </TableRow>
              <TableRow>
                {/* // type of language */}
                <TableCell>logistics</TableCell>
                <TableCell>sales</TableCell>
                <TableCell>marketing</TableCell>
                <TableCell>finance</TableCell>
                <TableCell>legal</TableCell>
                <TableCell>engineering</TableCell>
                <TableCell>production</TableCell>
                <TableCell>quality</TableCell>
                <TableCell>it</TableCell>
                <TableCell>hr</TableCell>
                <TableCell>other</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{globalNeeds.logistics}</TableCell>
                <TableCell>{globalNeeds.sales}</TableCell>
                <TableCell>{globalNeeds.marketing}</TableCell>
                <TableCell>{globalNeeds.finance}</TableCell>
                <TableCell>{globalNeeds.legal}</TableCell>
                <TableCell>{globalNeeds.engineering}</TableCell>
                <TableCell>{globalNeeds.production}</TableCell>
                <TableCell>{globalNeeds.quality}</TableCell>
                <TableCell>{globalNeeds.it}</TableCell>
                <TableCell>{globalNeeds.hr}</TableCell>
                <TableCell>{globalNeeds.otherPro}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginBottom: '10px' }}>
          <Table>
            <TableHead style={{ backgroundColor: '#DADFEA' }}>
              <TableRow>
                <TableCell colSpan={9} align="center">General vocabulary</TableCell>
              </TableRow>
              <TableRow>
                {/* // type of language */}
                <TableCell>news</TableCell>
                <TableCell>environment</TableCell>
                <TableCell>economy</TableCell>
                <TableCell>politics</TableCell>
                <TableCell>art</TableCell>
                <TableCell>sport</TableCell>
                <TableCell>travelling</TableCell>
                <TableCell>education</TableCell>
                <TableCell>leisure</TableCell>
                <TableCell>other</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{globalNeeds.news}</TableCell>
                <TableCell>{globalNeeds.environment}</TableCell>
                <TableCell>{globalNeeds.economy}</TableCell>
                <TableCell>{globalNeeds.politics}</TableCell>
                <TableCell>{globalNeeds.art}</TableCell>
                <TableCell>{globalNeeds.sport}</TableCell>
                <TableCell>{globalNeeds.travelling}</TableCell>
                <TableCell>{globalNeeds.education}</TableCell>
                <TableCell>{globalNeeds.leisure}</TableCell>
                <TableCell>{globalNeeds.otherVoc}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginBottom: '10px' }}>
          <Table>
            <TableHead style={{ backgroundColor: '#DADFEA' }}>
              <TableRow>
                <TableCell colSpan={6} align="center">Professional skills</TableCell>
              </TableRow>
              <TableRow>
                {/* // type of language */}
                <TableCell>meetings</TableCell>
                <TableCell>presentations</TableCell>
                <TableCell>negotiations</TableCell>
                <TableCell>emails</TableCell>
                <TableCell>telephoning</TableCell>
                <TableCell>other</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{globalNeeds.meetings}</TableCell>
                <TableCell>{globalNeeds.presentations}</TableCell>
                <TableCell>{globalNeeds.negotiations}</TableCell>
                <TableCell>{globalNeeds.emails}</TableCell>
                <TableCell>{globalNeeds.telephoning}</TableCell>
                <TableCell>{globalNeeds.otherWorksRelated}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NeedsDialog;
